
export default function Footer() {
    return (
        <footer className="mt-5">
            <div className="py-4 px-5 bg-gray-800 text-gray-100 font-semibold text-center ">
                <div className="capitalize">GoCooking @2020
                    <div>
                        <a className="underline" href="https://github.com/tomorisakura/unofficial-masakapahariini-api">
                        Api from Unofficial-masakapahariini
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    )
}
